/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {
  Phone,
  Mail,
  MapPin,
  Facebook,
  Youtube,
  Linkedin,
  Instagram,
  Twitter,
} from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className="py-12" style={{ background: "rgb(240 246 255)" }}>
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-bold mb-4">BPO</h3>
              <ul>
                <li className="mb-2">
                  <Link
                    to="/bpo"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    BPO
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/inbound"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    Inbound Calls
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/outbound"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    Outbound Calls
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/email-support"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    Email and Chat Support
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/sms-support"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    SMS Support
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">Health Care</h3>
              <ul>
                <li className="mb-2">
                  <Link
                    to="/healthcare"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    HealthCare Sol
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/medical-billing"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    Medical Billing
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/medical-transcription"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    Medical Transcriptions
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/excellence"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    Management Services
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">Digital Marketing</h3>
              <ul>
                <li className="mb-2">
                  <Link
                    to="/web"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    WEB Development
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/graphics"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    Graphic Designing
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/uiux"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    UI UX Designing
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/seo"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    Search Engine Optimization
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/social"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    Social Media Marketing
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/content"
                    className="text-gray-600 hover:text-blue-500"
                    onClick={scrollToTop}
                  >
                    Content Writing
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">Contact Us</h3>
              <p className="flex items-center mb-2">
                <span className="mr-2">📞</span> +923394017907
              </p>
              <p className="flex items-center mb-2">
                <span className="mr-3">✉</span> info@rightontime.biz
              </p>
              <p className="flex items-start">
                <span className="mr-2 mt-1">📍</span> 1st Floor, Al, Al-Rehman
                Chamber, Fazal e Haq Road, G 7/3 Blue Area, Islamabad, 44000
              </p>
            </div>
          </div>
        </div>
      </footer>
      <div className="bg-indigo-900 text-white py-4 px-6 md:px-12 lg:px-24 xl:px-32 ">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between max-w-6xl mx-auto items-center">
          <p className="text-sm">
            &copy; {currentYear} Right on Time Services. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-3 md:mt-0">
            <a href="#" className="hover:text-gray-300 transition">
              <Facebook className="h-5 w-5" />
            </a>
            <a href="#" className="hover:text-gray-300 transition">
              <Youtube className="h-5 w-5" />
            </a>
            <a href="#" className="hover:text-gray-300 transition">
              <Linkedin className="h-5 w-5" />
            </a>
            <a href="#" className="hover:text-gray-300 transition">
              <Instagram className="h-5 w-5" />
            </a>
            <a href="#" className="hover:text-gray-300 transition">
              <Twitter className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
